module.exports = __webpack_public_path__ + "img/orders.c8045a94.svg";